import { Spacer } from '@spritz-finance/ui'
import styled, { css } from 'styled-components'
import { Row } from '../../../../../components/Layout/Row'
import { PayableAccountType } from '../../../../../graphql/generated/graphql'
import { typeDescription } from '../BillIcon'
import { Bill } from '../Bills'
import { CreateSubscriptionButton } from './create/CreateSubscriptionButton'

const StyledRow = styled(Row)<{ $hidden: boolean }>`
    ${({ $hidden }) =>
        $hidden &&
        css`
            display: none;
        `}
`

export const SetupBillSubscription = ({
    bill,
    hasSubscription,
}: {
    bill: Bill
    hasSubscription: boolean
}) => {
    return (
        <>
            <StyledRow align="center" $hidden={hasSubscription}>
                <CreateSubscriptionButton
                    account={{
                        id: bill.id,
                        provider: bill.provider,
                        logoUrl: bill.institution?.logoUrl,
                        name: bill.name,
                        description: typeDescription[bill.type],
                        type: PayableAccountType.Bill,
                    }}
                />
            </StyledRow>
            {!hasSubscription && <Spacer height={24} />}
        </>
    )
}
